<template>
  <svg
    :width="width"
    :height="height"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 500 500"
  >
    <g>
      <path class="st0" d="M74.3,63h373.1v373L74.3,63z" />
      <path class="st1" d="M52.6,275.5h161.6V437L52.6,275.5z" />
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'ZendeskSellLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
};
</script>

<style type="text/css">
  .st0 {
    fill: #d4ae5e;
  }
  .st1 {
    fill: #00363d;
  }
</style>
